import Header from './components/Header';
import HeroSection from './components/HeroSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import FAQSection from './components/FAQSection';
import FeaturesSection from './components/FeaturesSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <CarouselSection />
        <FAQSection />
        <FeaturesSection />
        <ContactSection />
        <CommentsSection />
        <AppSection />
        <CardsSection />
        <TopicsSection />
        <UpdatesSection />
        <AboutSection />
        <RankingSection />
        <MediaSection />
      </main>
      <Footer />
    </div>
  );
}